// EG-27 (rework): janela de validade por MÊS/ANO. O <Input type="month"> usa
// "YYYY-MM"; o backend guarda date (YYYY-MM-DD). Início = 1º dia do mês;
// fim = último dia do mês ("até o fim dele").

export function monthToStartDate(ym) {
  if (!ym) return null;
  return `${ym}-01`;
}

export function monthToEndDate(ym) {
  if (!ym) return null;
  const [year, month] = ym.split('-').map(Number);
  // Day 0 do mês seguinte = último dia do mês atual.
  const last = new Date(year, month, 0).getDate();
  return `${ym}-${String(last).padStart(2, '0')}`;
}

// date (YYYY-MM-DD) → "YYYY-MM" para preencher o input month.
export function dateToMonth(dateStr) {
  if (!dateStr) return '';
  return String(dateStr).slice(0, 7);
}
